class PlainEditorView extends Backbone.View
  template: JST['backbone/templates/plaineditor']

  @create: ($el, options) ->
    new PlainEditorView($.extend({ el: $el }, options))

  initialize: (@options) ->
    @text = @options.text
    @textareaId = UniqueId.generate()

  render: ->
    @$el.html(@template({ @textareaId, @text }))
    @textarea = @$el.find("##{@textareaId}")
    @

  update: ->
    @text = @textarea.val()

  focus: =>
    @textarea.focus()

  insertTextAtCursor: (text) =>
    insertTextAtCursor(@textarea.get(0), text)

  getPlainHTML: ->
    undefined

  getPlainText: ->
    @text

window.PlainEditorView = PlainEditorView
